import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appNoWhitespace]'
})
export class NoWhitespaceDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0 && this.control.control) {
      this.control.control.setValue('');
    }
  }
}